import { ref, computed } from '@vue/composition-api'
import useHttpGet from '@/states/generics/useHttpGet'
import useHttpPost from '@/states/generics/useHttpPost'
import useUser from 'states/useUser'
import useOrg from 'states/useOrg'

export function useShortlists() {
  const shortlists = ref([])

  const url = '/startups/shortlists'
  const { get, getInProgress } = useHttpGet({ url })

  const fetchShortlists = async () => {
    const req = get()
    const res = await req
    shortlists.value = res.data
    return shortlists.value
  }

  const {
    createShortlist,
    createShortlistInProgress,
    updateShortlist,
    updateShortlistInProgress,
    errors,
    org,
  } = useManageShortlists()

  const { setStartupShortlists, isSetStartupShortlistsInProgress } =
    useManageStartupShortlist()

  return {
    shortlists,
    fetchShortlists,
    fetchShortlistsInProgress: getInProgress,

    createShortlist,
    createShortlistInProgress,
    updateShortlist,
    updateShortlistInProgress,
    org,
    errors,

    setStartupShortlists,
    isSetStartupShortlistsInProgress,
  }
}

function useManageShortlists() {
  const { user } = useUser()

  const {
    post,
    postInProgress,
    errors: createErrors,
  } = useHttpPost({
    url: '/startups/shortlists/create',
  })

  const { org } = useOrg({ id: user.value.organizationId })

  const createShortlist = async ({ name, organizationId }) => {
    const data = { name }
    if (
      organizationId &&
      user.value.organizationId &&
      user.value.organizationId === organizationId
    ) {
      data.organization_id = organizationId
    }
    return await post(data)
  }

  const updateShortlistInProgress = ref(false)
  const updateErrors = ref({})
  const updateShortlist = async ({ id, name }) => {
    const { post, errors } = useHttpPost({
      url: `/startups/shortlists/${id}/update`,
    })
    const data = { name }
    updateShortlistInProgress.value = true
    try {
      await post(data)
    } finally {
      updateShortlistInProgress.value = false
      updateErrors.value = errors.value
    }
  }

  const errors = computed(() => {
    return { ...createErrors.value, ...updateErrors.value }
  })

  return {
    createShortlist,
    createShortlistInProgress: postInProgress,
    updateShortlist,
    updateShortlistInProgress,
    org,
    errors,
  }
}

function useManageStartupShortlist() {
  const inProgress = ref(false)

  const setStartupShortlists = async ({ startupId, shortlistIds }) => {
    if (inProgress.value) {
      throw new Error(
        'setStartupShortlists should not be called if previous action did not complete yet',
      )
    }
    const url = `/startups/${startupId}/set-shortlists`
    const { post } = useHttpPost({ url, sleep: 750 })

    inProgress.value = true
    try {
      await post({ shortlist_ids: shortlistIds })
    } finally {
      inProgress.value = false
    }
  }

  return {
    setStartupShortlists,
    isSetStartupShortlistsInProgress: inProgress,
  }
}
